var map = {
	"./baby.png": 702,
	"./birthday1.png": 6981,
	"./cat.png": 8725,
	"./christmas1.png": 3675,
	"./christmas2.png": 29,
	"./christmas3.png": 6746,
	"./cloud.png": 3794,
	"./couple.png": 950,
	"./graduation.png": 6290,
	"./group.png": 2264,
	"./lovemate1.png": 1072,
	"./lovemate2.png": 7278,
	"./mates.png": 5294,
	"./mountains1.png": 7660,
	"./rings.png": 2771,
	"./road.png": 3032,
	"./seaship.png": 7867,
	"./trip.png": 6569,
	"./valentine.png": 4197,
	"./wavesun.png": 5133,
	"./world.png": 6906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4096;